/**
 * Load More — AJAX pagination for collection grids
 * Appends next-page products without a full page reload.
 */
(function () {
  'use strict';

  function init() {
    const btn = document.querySelector('.load-more-btn');
    if (!btn) return;
    btn.addEventListener('click', handleClick);
  }

  async function handleClick(e) {
    const btn = e.currentTarget;
    if (btn.classList.contains('is-loading')) return;

    const nextUrl   = btn.dataset.nextUrl;
    const sectionId = btn.dataset.sectionId;
    if (!nextUrl) return;

    // Show loading state
    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      const sep = nextUrl.includes('?') ? '&' : '?';
      const url = `${nextUrl}${sep}section_id=${sectionId}`;

      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      // Append new product <li> items to the existing grid
      const newItems    = doc.querySelectorAll('#product-grid > .grid__item');
      const existingGrid = document.getElementById('product-grid');

      if (!existingGrid) throw new Error('Product grid not found');

      newItems.forEach(item => {
        // Strip scroll-trigger cancel class that Shopify adds in section renders
        item.classList.remove('scroll-trigger--cancel');
        existingGrid.appendChild(item);
      });

      // Check if there is yet another page
      const newBtn = doc.querySelector('.load-more-btn');
      if (newBtn && newBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        btn.classList.remove('is-loading');
        btn.disabled = false;
      } else {
        // No more pages — remove the button gracefully
        const wrapper = btn.closest('.load-more-wrapper');
        if (wrapper) {
          wrapper.style.transition = 'opacity 0.3s';
          wrapper.style.opacity    = '0';
          setTimeout(() => wrapper.remove(), 300);
        } else {
          btn.remove();
        }
      }
    } catch (err) {
      console.error('[Load More]', err);
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
